import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { DateFilterTypes } from 'app/modules/common/enums/date-filter-enums';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { FilterService } from 'app/modules/selection-generic/services/filter.service';

@Component({
    selector: 'app-leave-selection-filters',
    templateUrl: './leave-selection-filters.component.html',
    styleUrls: ['./leave-selection-filters.component.scss'],
    standalone: false
})
export class LeaveSelectionFiltersComponent implements OnInit {

  DateFilterType = DateFilterTypes;
  CommonDateFrom = new UntypedFormControl();
  CommonDateTo = new UntypedFormControl();

  LeaveSelectionFilterForm: UntypedFormGroup = this.formBuilder.group({
    ActiveLeaves: [true],
    EmpresaSelec: [true],
    BajasOrdern: ['Trabajador']
  });

  constructor(private formBuilder: UntypedFormBuilder, private selectionService: SelectionGenericService,public filterServcie: FilterService) { }

  ngOnInit(): void {
    this.selectionService.leaveSelectionModal.BajasOrdern = this.LeaveSelectionFilterForm.value.BajasOrdern;
  }

  public SetFilterValues(filterType: string, data: Date = null, selection: any = null): void {
    switch (filterType) {
      case 'activeLeaves':
        this.selectionService.leaveSelectionModal.IsActiveLeave = this.LeaveSelectionFilterForm.value.ActiveLeaves;
        break;

      case 'empresaSelec':
        this.selectionService.leaveSelectionModal.EmpresaSelec = this.LeaveSelectionFilterForm.value.EmpresaSelec;
        break;

      case 'commonDateFrom':
        this.selectionService.leaveSelectionModal.CommonDateFrom = DateHelper.getUTCDateString(data);
        break;

      case 'commonDateTo':
        this.selectionService.leaveSelectionModal.CommonDateTo = DateHelper.getUTCDateString(data);
        break;
        case 'Ordern':
          this.selectionService.leaveSelectionModal.Ordern = selection.selectedValue;
          break;
      default:
        break;
    }
  }

}
